const filterMonthlyInterest = data => {
  const interestLevels = ['Altíssimo', 'Alto', 'Médio', 'Baixo']
  const backgroundColors = ['#28a745', '#ffc107', '#fd7e14', '#dc3545']

  return {
    labels: interestLevels,
    datasets: [
      {
        label: 'Interesse mensal',
        data: interestLevels.map(level => data.filter(item => item.interest === level).length),
        backgroundColor: backgroundColors,
      },
    ],
  }
}

export default filterMonthlyInterest
